import { logger } from '@lusha/client-logger';
import { flow, types } from 'mobx-state-tree';
import { contactSearchFiltersData } from '../../API/SearchContactApi';
const CountryFilter = types.model({
    value: types.model({
        name: types.string,
        code: types.string,
    }),
    label: types.string,
});
const Filter = types.model({
    value: types.string,
    label: types.string,
});
const Model = {
    countries: types.optional(types.array(CountryFilter), []),
    departments: types.optional(types.array(Filter), []),
    industries: types.optional(types.array(Filter), []),
    seniority: types.optional(types.array(Filter), []),
};
const actions = self => ({
    setSearchFilters: data => {
        self.countries = data.countries;
        self.departments = data.departments;
        self.industries = data.industries;
        self.seniority = data.senioritis;
    },
    fetchSearchFilters: flow(function* fetchSearchFilters() {
        try {
            const data = yield contactSearchFiltersData();
            self.setSearchFilters(data);
        }
        catch (error) {
            logger.info('Failed to fetch search filters: ', error);
        }
    }),
});
const views = self => ({
    get seniorityFilters() {
        return self.seniority.map(filter => filter.value);
    },
});
const SearchFiltersModel = types.model(Model).actions(actions).views(views);
export default SearchFiltersModel;
